import axiosInstance from '../api/axios';

export interface SupportChat {
  id: number;
  tg_chat_id: number;
  name: string;
  trader_id: string;
}

export const supportService = {
  getChats: async (params?: { name?: string | null; trader_id?: string | null }) => {
    const response = await axiosInstance.get<SupportChat[]>('/support/chats', {
      params,
    });
    return response.data;
  },

  createChat: async (data: { tg_chat_id: number; name: string; trader_id: string }) => {
    const response = await axiosInstance.post<SupportChat>('/support/chats', data);
    return response.data;
  },

  updateChat: async (
    chatId: number,
    data: { tg_chat_id: number; name: string; trader_id: string },
  ) => {
    const response = await axiosInstance.patch<SupportChat>(
      `/support/chats/${chatId}`,
      data,
    );
    return response.data;
  },
};

